var __rspack_ns_object = JSON.parse('{"UU":"main","rE":"4.1.2"}')